module.exports = __webpack_public_path__ + "img/still (10).47bf3dce.jpg";